import { ViewerCommand } from './ViewerCommand';
import { Quaternion } from 'three';
import { ViewerEvents } from '../../Viewer';
export class SetRotationCommand extends ViewerCommand {
    constructor(viewer, objects, newRotations, optionalOldRotations) {
        var _a;
        super(viewer, objects);
        this.type = 'SetRotationCommand';
        this.name = this.composeName();
        this.updatable = true;
        this.newRotations = newRotations.map((rotation) => rotation.clone());
        this.oldRotations = (_a = optionalOldRotations === null || optionalOldRotations === void 0 ? void 0 : optionalOldRotations.map((rotation) => rotation.clone())) !== null && _a !== void 0 ? _a : objects.map((object) => object.quaternion.clone());
    }
    execute() {
        this.objects.forEach((object, index) => {
            object.quaternion.copy(this.newRotations[index]);
            object.updateMatrixWorld(true);
        });
        this.viewer.emit(ViewerEvents.SetObjectsRotation, this.objects.map((object) => object.uuid));
    }
    undo() {
        this.objects.forEach((object, index) => {
            object.quaternion.copy(this.oldRotations[index]);
            object.updateMatrixWorld(true);
        });
        this.viewer.emit(ViewerEvents.SetObjectsRotation, this.objects.map((object) => object.uuid));
    }
    update(cmd) {
        if (this.newRotations.length !== cmd.newRotations.length) {
            throw Error(`Invalid update of ${this.type}. newRotations member must have equal length`);
        }
        this.newRotations.forEach((rotation, index) => rotation.copy(cmd.newRotations[index]));
    }
    toJSON() {
        const output = super.toJSON();
        output.oldRotations = this.oldRotations.map((rotation) => rotation.toArray());
        output.newRotations = this.newRotations.map((rotation) => rotation.toArray());
        return output;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.oldRotations = json.oldRotations.map((rotation) => new Quaternion().fromArray(rotation));
        this.newRotations = json.newRotations.map((rotation) => new Quaternion().fromArray(rotation));
    }
}
